import React from "react";
import style from "./authlayout.module.scss";
import { Outlet } from "react-router-dom";

const AuthLayout = () => {
  return (
    <div className={style.auth_screen}>
      {/* ── LEFT: Green Branding Panel ─────────────────────────── */}
      <div className={style.left_child}>
        {/* Logo */}
        <div className={style.brand_logo}>
          <img src="/Latestdunwrklogo.svg" alt="dunwrk logo" width="180" height="56" />
           {/* <img src="/dunwrkfavlatest.svg" alt="dunwrk logo" /> */}
        </div>

        {/* Tagline */}
        <h1 className={style.tagline}>
          Your work,<br />simplified.
        </h1>
        <p className={style.tagline_sub}>
          Organize tasks, collaborate in real-time, and ship projects faster than ever.
        </p>

        {/* Feature bullets */}
        <ul className={style.features}>
          <li>
            <span className={style.feature_icon}>✓</span>
            Smart task management with AI workflows
          </li>
          <li>
            <span className={style.feature_icon}>⚡</span>
            Real-time collaboration &amp; instant sync
          </li>
          <li>
            <span className={style.feature_icon}>📊</span>
            Insightful dashboards &amp; detailed reports
          </li>
        </ul>

        {/* Stats */}
        <div className={style.stats}>
          <div className={style.stat_item}>
            <span className={style.stat_number}>10k+</span>
            <span className={style.stat_label}>Active Users</span>
          </div>
          <div className={style.stat_item}>
            <span className={style.stat_number}>50k+</span>
            <span className={style.stat_label}>Tasks Completed</span>
          </div>
          <div className={style.stat_item}>
            <span className={style.stat_number}>99.9%</span>
            <span className={style.stat_label}>Uptime</span>
          </div>
        </div>
      </div>

      {/* ── RIGHT: White Form Panel ────────────────────────────── */}
      <div className={style.right_child}>
        <div className={style.form_wrapper}>
          {/* Logo — only visible on mobile (left panel is hidden on mobile) */}
          <div className={style.mobile_logo}>
            <img src="/Latestdunwrklogo.svg" alt="dunwrk logo" width="160" height="50" />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;